import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { adminMe } from '../lib/api';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [state, setState] = useState({ checking: true, authed: false });

  useEffect(() => {
    let mounted = true;
    adminMe()
      .then(() => mounted && setState({ checking: false, authed: true }))
      .catch(() => mounted && setState({ checking: false, authed: false }));
    return () => { mounted = false; };
  }, []);

  if (state.checking) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center" data-testid="protected-checking">
        <p className="text-gray-500">Verificando acesso...</p>
      </div>
    );
  }

  if (!state.authed) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export default ProtectedRoute;
